import { Components } from 'src/components';
import { setComponentAttributes } from 'shared/storybook-utils';

export default {
  title: 'Components/List',
  component: 'a1-list',
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: 'List Component - Displays an unordered list.',
      },
    },
    layout: 'centered',
  },
};

const elementName = 'a1-list';

const Template = (args: Components.A1List): HTMLA1ListElement => {
  const elComponent = document.createElement(elementName);

  Object.entries(args).forEach(([key, value]) => {
    setComponentAttributes({ element: elComponent, key, value });

    if (key === 'htmlText' && value) {
      elComponent.innerHTML = `
      <ul>
        <li>Coffee</li>
        <li>Tea</li>
        <li>Milk <a1-link href="#" text="Link to shop"></a1-link></li>
      </ul>
      `;
    }
  });

  return elComponent;
};

export const Default: Story<Components.A1List> = Template.bind({});
Default.args = {
  items: '["Item 1", "Item 2", "Item 3"]',
};

export const CustomIcon: Story<Components.A1List> = Template.bind({});
CustomIcon.args = {
  ...Default.args,
  icon: 'check',
};

export const ColorfulWithCheckIcon: Story<Components.A1List> = Template.bind({});
ColorfulWithCheckIcon.args = {
  ...Default.args,
  icon: 'check',
  colorful: true,
};

export const ColorfulWithCrossIcon: Story<Components.A1List> = Template.bind({});
ColorfulWithCrossIcon.args = {
  ...Default.args,
  icon: 'product-cross',
  colorful: true,
};

export const HTMLText: Story<Components.A1List> = Template.bind({});
HTMLText.args = {
  ...Default.args,
  htmlText: true,
  items: '',
};
